export const getInitials = (string) => {
  if (typeof string === 'undefined') return;
  const initials = string.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);
  return initials[0] + initials[1];
};
